import { useCallback } from "react";
import { useNavigate } from "react-router";

import { savePriorClaims } from "@covertree/new-business-redux";

import { PriorClaim } from "@covertree/agent-portal-graphql";
import { useAppDispatch } from "@redux/hooks";
import { NewPolicyRoutes, navigateToPolicyStep } from "@routing/paths";
import { ClaimsList } from "@covertree/new-business-past-claims";

export function ClaimsListStep() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSubmitClaimsForm = useCallback(
    async (priorClaims: PriorClaim[]) => {
      try {
        await dispatch(
          savePriorClaims({
            priorClaims,
          })
        ).unwrap();
        navigateToPolicyStep(
          navigate,
          NewPolicyRoutes.POLICY_SUMMARY,
          NewPolicyRoutes.CLAIMS_LIST
        );
      } catch {
        navigateToPolicyStep(
          navigate,
          NewPolicyRoutes.ERROR,
          NewPolicyRoutes.CLAIMS_LIST
        );
      }
    },
    [dispatch, navigate]
  );

  return <ClaimsList onClaimsListSubmit={handleSubmitClaimsForm} />;
}
